<template>
  <div class="verify-card">
    <div class="verify-bar"></div>

    <div class="verify-icon" :class="status">
      <template v-if="status === 'code' || status === 'reset'">
        <img src="../../assets/images/svg-icon/shield.svg" height="32" />
      </template>
      <template v-else-if="status === 'success'">
        <div class="success-icon">✓</div>
      </template>
      <template v-else>
        <div class="error-icon">!</div>
      </template>
    </div>

    <template v-if="status === 'code'">
      <h2>Verifica tu código</h2>
      <p class="text-muted">
        Ingresa el código de recuperación enviado a<br />
        <strong>{{ email }}</strong>
      </p>

      <div class="code-inputs">
        <input
          v-for="(digit, i) in codeDigits"
          :key="i"
          maxlength="1"
          class="code-input"
          v-model="codeDigits[i]"
          @input="handleInput(i, $event)"
          @keydown.backspace="handleBackspace(i)"
          :ref="el => setInputRef(el, i)"
        />
      </div>

      <div class="validate-error" v-if="errorMessage">{{ errorMessage }}</div>

      <button class="btn btn-primary btn-lg w-100 mt-4" @click="submitCode" :disabled="!isCodeComplete">
        Validar código
      </button>
    </template>

    <template v-else-if="status === 'reset'">
      <h2>Nueva contraseña</h2>
      <p class="text-muted">
        Crea una nueva contraseña para tu cuenta.
      </p>

      <input
        type="password"
        class="form-control form-control-lg mt-4"
        placeholder="Nueva contraseña"
        v-model="password"
      />
      <input
        type="password"
        class="form-control form-control-lg mt-3"
        placeholder="Confirmar contraseña"
        v-model="passwordConfirmation"
      />

      <div class="validate-error text-start mt-2" v-if="errorMessage">{{ errorMessage }}</div>

      <button class="btn btn-primary btn-lg w-100 mt-4" @click="submitPassword">
        Guardar contraseña
      </button>
    </template>

    <template v-else-if="status === 'success'">
      <h2>¡Contraseña actualizada!</h2>
      <p class="text-muted">
        Tu contraseña se cambió correctamente.
      </p>

      <button class="btn btn-primary btn-lg w-100 mt-4" @click="$emit('login')">
        Ir a iniciar sesión
      </button>
    </template>

    <template v-else>
      <h2>Código inválido</h2>
      <p class="text-muted">
        El código no es válido o expiró. Solicita uno nuevo para continuar.
      </p>

      <button class="btn btn-primary btn-lg w-100 mt-4" @click="retry">
        Intentar de nuevo
      </button>

      <p class="resend mt-3">
        ¿Necesitas otro código?
        <a href="javascript:void(0)" @click="$emit('recover')">Solicitar nuevo código</a>
      </p>
    </template>
  </div>
</template>

<script>
export default {
  name: 'PasswordStatusCard',
  props: {
    email: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: 'code' // code | reset | success | error
    }
  },
  data() {
    return {
      codeDigits: ['', '', '', '', '', ''],
      inputRefs: [],
      password: '',
      passwordConfirmation: '',
      errorMessage: ''
    }
  },
  computed: {
    isCodeComplete() {
      return this.codeDigits.every(d => d !== '')
    }
  },
  methods: {
    setInputRef(el, index) {
      if (el) {
        this.inputRefs[index] = el
      }
    },
    handleInput(index, event) {
      const value = event.target.value

      if (!/^[a-zA-Z0-9]$/.test(value)) {
        this.codeDigits[index] = ''
        return
      }

      this.codeDigits[index] = value.toUpperCase()

      if (index < this.codeDigits.length - 1) {
        this.inputRefs[index + 1]?.focus()
      }
    },
    handleBackspace(index) {
      if (this.codeDigits[index] === '' && index > 0) {
        this.inputRefs[index - 1]?.focus()
      }
    },
    submitCode() {
      this.errorMessage = ''
      if (!this.isCodeComplete) {
        this.errorMessage = 'Ingresa el código completo'
        return
      }

      const code = this.codeDigits.join('')
      this.$emit('verify', code)
    },
    submitPassword() {
      this.errorMessage = ''

      if (!this.password || !this.passwordConfirmation) {
        this.errorMessage = 'Ingresa y confirma la nueva contraseña'
        return
      }

      if (this.password.length < 8) {
        this.errorMessage = 'La contraseña debe tener al menos 8 caracteres'
        return
      }

      if (this.password !== this.passwordConfirmation) {
        this.errorMessage = 'Las contraseñas no coinciden'
        return
      }

      this.$emit('save', {
        password: this.password,
        password_confirmation: this.passwordConfirmation
      })
    },
    retry() {
      this.errorMessage = ''
      this.codeDigits = ['', '', '', '', '', '']
      this.$emit('retry')
    }
  }
};
</script>
